module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "city",
    staticClass: ["dof-city"],
    style: _vm.cityExtendStyle
  }, [_c('dof-searchbar', _vm._b({
    ref: "dof-searchbar",
    on: {
      "dofSearchbarInputOnInput": _vm.onInput,
      "dofSearchbarInputReturned": _vm.onSubmit,
      "dofSearchbarCancelClicked": _vm.onCancel
    }
  }, 'dof-searchbar', _vm.mergeInputConfig, false)), (_vm.showTab) ? _c('dof-tab', {
    ref: "dof-tab",
    on: {
      "dofTabSwitch": _vm.onTabSwitch
    }
  }) : _vm._e(), _c('dof-indexlist', {
    attrs: {
      "normalList": _vm.normalList,
      "hotListConfig": _vm.hotListConfig,
      "navStyle": {
        top: '24px'
      },
      "height": _vm.listHeight,
      "showIndex": _vm.showIndex,
      "onlyShowList": !_vm.showNavHeader || _vm.onlyShowList,
      "cityLocationConfig": _vm.currentCityLocationConfig
    },
    on: {
      "dofIndexlistItemClicked": _vm.onItemClick
    }
  }), (_vm.showError) ? _c('dof-result', {
    attrs: {
      "type": "noGoods",
      "wrapStyle": {
        top: '84px'
      },
      "show": true,
      "customSet": _vm.result
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-743fe044!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-city/index.vue
// module id = 643
// module chunks = 0 1